import { getProcessListType } from "./AppPath";

export function getNewLink() {
    return getProcessListType() + "/New";
}

export function getEditLink(processId: number) {
    return getProcessListType() + "/Edit/" + processId;
}

export function getDraftEditLink(draftId: number) {
    return getProcessListType() + "/Draft/" + draftId;
}

export const getExportLink = (ids: number[])  => {
    const idsString = "ids=" + ids.join("&ids=");
    return "Export/Export?type=process&" + idsString;
};
